// Bootstrap JS.
// Comment out the library you are not using.
// -----------------------------------------------------------------------------
import * as bootstrap from 'bootstrap';
import "./_tooltip-init";
import "./_toast-init";

window.bootstrap = bootstrap;
